import React from 'react'
import { Spinner } from 'reactstrap'
import UserInfoForm from './UserInfoForm'

const renderNoteContent = (content) => {
  if (typeof content !== 'string') return content
  const urlRegex = /(https?:\/\/[^\s]+)/g
  const parts = content.split(urlRegex)
  return parts.map((part, i) => {
    if (part.match(/^https?:\/\//)) {
      return (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="edv2-note-link">
          {part}
        </a>
      )
    }
    return part
  })
}

const OrderSummaryFooter = ({
  payLater,
  totalPrice,
  discountAmount,
  originalTotal,
  adminCost,
  termCond = '',
  showPurchaseOnBehalf,
  isPurchase,
  onTogglePurchase,
  phoneOrEmail,
  onChangePhoneOrEmail,
  bookingAddressRequired,
  edittingOrder,
  displayAddress,
  displayDeliveryDate,
  onChangeAddressClick,
  comment,
  onChangeComment,
  error,
  allowPlaceOrder,
  isSubmitted,
  onCancel,
  onSubmit,
  userInfo,
  isGuestCheckout,
  onGuestFormChange,
  onLoginClick,
}) => {
  const validTermConds = typeof termCond === 'string'
    ? termCond.split(/\r?\n/).map((line) => line.trim()).filter(Boolean)
    : Array.isArray(termCond)
      ? termCond.filter(Boolean)
      : []
  const hasTermConds = validTermConds.length > 0
  const showHostNote = !isGuestCheckout
  const hasNotes = hasTermConds || showHostNote

  return (
    <div className="edv2-summary">
      <div className="edv2-summary-card">
        <div className="edv2-summary-card__top">
          <span className="edv2-summary-card__label">Order Total</span>
          <span className="edv2-summary-card__total">
            ${totalPrice}
            {Number(discountAmount) > 0 && originalTotal && (
              <>
                {' '}
                <span
                  className="text-decoration-line-through"
                  style={{ color: '#b8bbbe', fontWeight: 'normal' }}
                >
                  ${originalTotal}
                </span>
              </>
            )}{' '}
            SGD
          </span>
        </div>

        {(showPurchaseOnBehalf || Number(adminCost) > 0) && (
          <div className="edv2-summary-card__bottom">
            <div className="edv2-summary-card__behalf">
              {showPurchaseOnBehalf && (
                <span className="edv2-summary-card__link" onClick={onTogglePurchase}>
                  Purchase-on-Behalf
                </span>
              )}
            </div>
            {Number(adminCost) > 0 && (
              <span className="edv2-summary-card__admin-fee">
                Admin fee included: ${adminCost}
              </span>
            )}
          </div>
        )}

        {payLater && (
          <div className="edv2-summary-card__paylater">
            <p className="edv2-paylater-note">
              <b>PAY LATER:</b>
              <br />
              Host requests payment to be made after the event closed. Sharing of delivery charges,
              discounts and admin fee may apply.
            </p>
          </div>
        )}
      </div>

      {isPurchase && (
        <input
          className="edv2-input"
          placeholder="Phone or email"
          value={phoneOrEmail}
          onChange={(e) => onChangePhoneOrEmail(e.target.value.trim())}
        />
      )}

      {bookingAddressRequired && edittingOrder && displayAddress && (
        <div className="edv2-address-block">
          <p>Deliver to this address: {displayAddress}</p>
          {displayDeliveryDate && <p>Delivery Date: {displayDeliveryDate}</p>}
          <span className="edv2-link" onClick={onChangeAddressClick}>
            Change your address
          </span>
        </div>
      )}

      {!userInfo && (
        <div className="edv2-guest-form-wrapper">
          <UserInfoForm
            onFormChange={onGuestFormChange}
            onLoginClick={onLoginClick}
          />
        </div>
      )}

      {hasNotes && (
        <div className="edv2-notes-box">
          {hasTermConds && (
            <div className="edv2-notes-box__please-note">
              <div className="edv2-notes-box__title">PLEASE NOTE</div>
              <div className="edv2-notes-box__list">
                {validTermConds.map((item, index) => (
                  <div key={index} className="edv2-notes-box__item">
                    <span className="edv2-notes-box__bullet">•</span>
                    <span>{renderNoteContent(item)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {showHostNote && (
            <div className="edv2-notes-box__host-note">
              <div className="edv2-notes-box__title">NOTES TO THE HOST</div>
              <textarea
                id="edv2-note"
                className="edv2-notes-box__textarea"
                placeholder="Optional message to the host..."
                value={comment}
                onChange={(e) => onChangeComment(e.target.value)}
              />
            </div>
          )}
        </div>
      )}

      {error && <small className="edv2-error">{error}</small>}

      {allowPlaceOrder && (
        <div className="edv2-actions">
          <button type="button" className="edv2-button edv2-button--outline" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="edv2-button edv2-button--solid" onClick={onSubmit} disabled={isSubmitted}>
            {isSubmitted ? <Spinner color="light" size="sm" /> : 'Place Order'}
          </button>
        </div>
      )}
    </div>
  )
}

export default OrderSummaryFooter
